import { BookingsState } from '../../../routes/reducers/types';
import { BookingsActions, SET_MIN_STAY } from '../actions/types';

const initialState: BookingsState = {
  minStay: 1,
};

export default (state = initialState, action: BookingsActions): BookingsState => {
  switch (action.type) {
    case SET_MIN_STAY:
      return { ...state, minStay: action.minStay };
    default:
      return state;
  }
};
